($ => {
	function scrollablePagerToggle() {
		const pagers = $('.pager');
		pagers.map((_, pager) => {
			const buffer = 1; // IE11 calcule la width d'un item avec 1px de moins que tous les autres browsers
			const element = $('.pager__inner-pager', pager).get(0);
			if (element) {
				const isScrollable = Math.ceil(element.offsetWidth) < element.scrollWidth - buffer;
				if(isScrollable) {
					pager.classList.add('pager_scrollable');
				} else {
					pager.classList.remove('pager_scrollable');
				}
			}
		});
	}

	function init(){
		const havePager = $('.pager').length > 0;
		if(havePager) {
			scrollablePagerToggle();
			$(window).resize(scrollablePagerToggle);
		}
	}

	$(init);
})(jQuery);
